import { getDivision } from '_legacy/reducers/userSelectors';
import client from './graphQlClient';
import {
    GET_VESSEL_BY_IMO_QUERY,
    SEARCH_VESSELS,
} from './queries/VesselQueries';
import store from 'store';

export class VesselsApi {
    static searchVessel = (
        name,
        datasetId,
        minCapacity,
        maxCapacity,
        searchVesselsWithImoOnly,
        cancelToken
    ) => {
        const division = getDivision(store.getState());
        return new Promise((resolve, reject) => {
            client()
                .query({
                    query: SEARCH_VESSELS,
                    fetchPolicy: 'no-cache',
                    variables: {
                        searchTerm: name,
                        datasetId,
                        minCapacity: minCapacity,
                        maxCapacity: maxCapacity,
                        searchVesselsWithImoOnly,
                        division,
                    },
                })
                .then((result) => {
                    resolve(result.data.vessels);
                });
            cancelToken.promise.then((reason) => {
                reject(reason);
            });
        });
    };

    static async fetchVesselByImo(datasetId, imo) {
        const division = getDivision(store.getState());
        const { data } = await client().query({
            query: GET_VESSEL_BY_IMO_QUERY,
            variables: { datasetId, imo, division },
            fetchPolicy: 'no-cache',
        });
        return data.vesselByImo;
    }
}
